const page = () => {
  return <div>Home</div>
}

export default page
